import React from "react";
import "./Footer.scss"
import { useSelector } from "react-redux";
import logo from "../../assets/images/logo2.png"
import fb from "../../assets/icons/fb.svg"
import insta from "../../assets/icons/insta.svg"
import tt from "../../assets/icons/tt.svg"
import pin from "../../assets/icons/loc.svg"
import email from "../../assets/icons/mail.svg"
import phone from "../../assets/icons/phone.svg"
import { useHistory } from "react-router";
import moment from "moment";
const Footer = () => {
    const history = useHistory()
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);
    const links = [
        {
            "Title": "Home",
            "href": "/"
        },
        {
            "Title": "About",
            "href": "/about"
        }, {
            "Title": "Menu",
            "href": "/menu"
        }, {
            "Title": "Gallery",
            "href": "/gallery"
        },
        {
            "Title": "Contact",
            "href": "/contact"
        },
    ]
    return (
        <div className="DosaChutneyFooter">
            <div className="DosaChutneyFooter-top">
                <div className="DosaChutneyFooter-top-item">
                    <div className="DosaChutneyFooter-top-item-logo">
                        <img
                            alt=""
                            src={logo} />
                    </div>

                    <div className="DosaChutneyFooter-top-item-content">
                        Authentic South Indian flavours, freshly prepared and served with warm hospitality at Dosa n Chutney</div>
                    <div className="DosaChutneyFooter-top-item-cont">
                        {company?.SocialMedias
                            ?.facebook && company?.SocialMedias
                                ?.facebook !== "" &&
                            <div className="DosaChutneyFooter-top-item-cont-ic"
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.facebook, '_blank')
                                }} >
                                <img alt="" src={fb} />
                            </div>}
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }}
                                    className="DosaChutneyFooter-top-item-cont-ic">
                                <img alt="" src={insta} />
                            </div>}
                        {company?.SocialMedias
                            ?.tiktok && company?.SocialMedias
                                ?.tiktok !== "" && <div className="DosaChutneyFooter-top-item-cont-ic"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tiktok, '_blank')
                                    }}>
                                <img alt="" src={tt} />
                            </div>}
                    </div>
                </div>
                <div className="DosaChutneyFooter-top-item">
                    <div className="DosaChutneyFooter-top-item-header">
                        QUICK LINKS
                    </div>
                    {links.map((link, key) => {
                        return (
                            <div className="DosaChutneyFooter-top-item-link" key={key}
                                onClick={() => {
                                    history.push(link.href)
                                }}>
                                {link.Title}
                            </div>
                        )
                    })}

                </div>
                <div className="DosaChutneyFooter-top-item">
                    <div className="DosaChutneyFooter-top-item-header">
                        Contact Us
                    </div>
                    <div className="DosaChutneyFooter-top-item-contVal"
                    >
                        <img alt="" src={pin} />
                        {companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}

                    </div>
                    <div className="DosaChutneyFooter-top-item-contVal"
                    >
                        <img alt="" src={phone} />
                        {companyDetails?.contactNumber}
                    </div>
                    <div className="DosaChutneyFooter-top-item-contVal2"
                    >
                        <img alt="" src={email} />
                        {companyDetails?.email}  </div>

                </div>
                <div className="DosaChutneyFooter-top-item">
                    <div className="DosaChutneyFooter-top-item-header">
                        Opening Hours
                    </div>
                    {companyDetails?.openingHours?.map((open, key) => {
                        return (<div key={key} className="DosaChutneyFooter-top-item-time">
                            <div className="DosaChutneyFooter-top-item-time-day">{open.Day}</div>
                            <div className="DosaChutneyFooter-top-item-time-val">{open?.Closed ? "Closed" : open.OpenHours?.map((date) => {
                                return (
                                    <div className="DosaChutneyFooter-top-item-time-val">{moment(date.StartTime, "HH:mm").format("hh:mm A") + " - " + moment(date.EndTime, "HH:mm").format("hh:mm A")}</div>
                                )
                            })}</div>
                        </div>)
                    })}

                </div>
            </div>
            <div className="DosaChutneyFooter-bottom">
                <div className="DosaChutneyFooter-bottom-left">
                    © 2026 Dosan Chutney. All rights reserved.
                </div>
                <div className="DosaChutneyFooter-bottom-right">
                    <div className="DosaChutneyFooter-bottom-right-item">
                        Privacy Policy
                    </div>
                    <div className="DosaChutneyFooter-bottom-right-item">
                        Terms of Service
                    </div> <div className="DosaChutneyFooter-bottom-right-item">
                        Cookie Policy
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer